import * as React from 'react'
import classnames from 'classnames'

import styles from './styles.module.scss'

interface Props extends React.HTMLProps<HTMLInputElement> {
  labelClassName?: string
  labelText: string
}

export const Radio: React.FC<Props> = ({ className, labelClassName, labelText, ...rest }) => {
  const inputClassName = classnames(styles.input, className)

  return (
    <label>
      <input className={inputClassName} type="radio" {...rest} />

      <div className={styles.label}>
        <span className={labelClassName}>{labelText}</span>
      </div>
    </label>
  )
}
